function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgorand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.585938 32 L 10.214844 23.984375 L 14.84375 16 L 19.441406 7.984375 L 20.203125 6.714844 L 20.542969 7.984375 L 21.953125 13.261719 L 20.375 16 L 15.746094 23.984375 L 11.144531 32 L 16.675781 32 L 21.304688 23.984375 L 23.703125 19.835938 L 24.832031 23.984375 L 26.976562 32 L 31.945312 32 L 29.800781 23.984375 L 27.65625 16 L 27.089844 13.941406 L 30.53125 7.984375 L 25.507812 7.984375 L 25.339844 7.394531 L 23.589844 0.847656 L 23.363281 0 L 18.539062 0 L 18.425781 0.167969 L 13.910156 7.984375 L 9.285156 16 L 4.683594 23.984375 L 0.0546875 32 Z M 5.585938 32 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorand);
export default __webpack_public_path__ + "static/media/algorand.636f2dd902f47d8dd17cd4b89da82236.svg";
export { ForwardRef as ReactComponent };